import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateCancellationInvoiceRequestModel } from '../common/CreateCancellationInvoiceRequestModel';
import { CreateCancellationInvoiceResponseModel } from '../common/CreateCancellationInvoiceResponseModel';
import { CreateInvoiceRequestModel } from '../common/CreateInvoiceRequestModel';
import { InvoiceGroupModel } from '../common/InvoiceGroupModel';
import { Invoice } from '../common/invoice';
import { InvoiceGroup } from '../common/InvoiceGroup';
import { ApiServiceBase } from './ApiServiceBase';
import { defaultDateRange, toApiDate } from '../common/date-helpers';
import { InvoiceFilter } from '../common/InvoiceFilter';
import { PagedResult, PagingParams, pagingToHttpParams } from '../common/PagedResult';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService extends ApiServiceBase {

  protected readonly path = 'invoice';

  getDefaultFilter(): InvoiceFilter {
    const { from, to } = defaultDateRange();
    return new InvoiceFilter('', from, to);
  }

  getSaleInvoicesBySearch(
    dateFrom?: Date,
    dateTo?: Date,
    customerNameOrNumber?: string,
    invoiceGroupId?: string,
    paging?: PagingParams,
  ): Observable<PagedResult<Invoice>> {
    return this.http
      .get<PagedResult<Invoice>>(this.getUrl() + '/sales', {
        params: {
          dateFrom: toApiDate(dateFrom),
          dateTo: toApiDate(dateTo),
          customerNameOrNumber: customerNameOrNumber == null ? '' : customerNameOrNumber,
          invoiceGroupId: invoiceGroupId == null ? '' : invoiceGroupId,
          ...pagingToHttpParams(paging),
        },
      });
  }

  public getSalesInvoiceGroups(dateFrom?: Date, dateTo?: Date): Observable<InvoiceGroup[]> {
    return this.http
      .get<InvoiceGroup[]>(this.getUrl() + '/sales/invoicegroups', {
        params: {
          dateFrom: toApiDate(dateFrom),
          dateTo: toApiDate(dateTo),
        },
      });
  }

  download(invoiceId: string): Observable<Blob> {
    return this.http
      .get(this.getUrl() + '/invoicedocument', {
        responseType: 'blob',
        params: { invoiceId: invoiceId.toString() },
      });
  }

  createInvoices(request: CreateInvoiceRequestModel): Observable<any> {
    return this.http
      .post<InvoiceGroupModel>(this.getUrl(), request);
  }

  CancelInvoice(
    request: CreateCancellationInvoiceRequestModel,
  ): Observable<CreateCancellationInvoiceResponseModel> {
    return this.http
      .post<CreateCancellationInvoiceResponseModel>(
        `${this.getUrl()}/cancel`,
        request
      );
  }
}
